import { useFeedbackStore } from '@stores/feedback'

import { useFeedbackOptionsApi } from '@api/feedback/options'
import { restoreFeedbackFromStorage } from '@hooks/feedback/feedback-local-storage.hook'

import { show404 } from '@utils/pages/error'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware( async (to) => {
  const feedbackStore = useFeedbackStore()

  const feedback = to?.params?.feedback as string | undefined
  const validFeedback = typeof feedback === 'string'

  if (!validFeedback) return show404()

  const bookingId = Number(feedback)
  const validBookingId = isFinite(bookingId)

  if (!validBookingId) return show404()

  if (!feedbackStore.isReady) {
    void useFeedbackOptionsApi(bookingId, {
      onError: () => {
        return show404()
      },
    })
  }

  restoreFeedbackFromStorage(bookingId)
})
